import React from 'react';

import HelmetLayout from '../../components/layouts/helmet_layout/helmet_layout';
import MainLayout from '../../components/layouts/main_layout/main_layout';
import WithGradientLayout from '../../components/layouts/with_gradient_layout/with_gradient_layout';

import AgriHeader from '../../components/solutions/agri/agri_header/agri_header';
import AgriInteractivePhoneSection from '../../components/solutions/agri/agri_interactive_phone_section/agri_interactive_phone_section';
import AgriInteractiveDesktopSection from '../../components/solutions/agri/agri_interactive_desktop_section/agri_interactive_desktop_section';
import AgriTestimonialsSection from '../../components/solutions/agri/agri_testimonials_section/agri_testimonials_section';

const Agri = () => (
	<HelmetLayout>
		<MainLayout
			footerProps={{
				dismissedSections: ['create-demo-account']
			}}
		>
			<AgriHeader />
			<WithGradientLayout>
				<AgriInteractivePhoneSection />
				<AgriInteractiveDesktopSection />
			</WithGradientLayout>
			<AgriTestimonialsSection />
		</MainLayout>
	</HelmetLayout>
);

export default Agri;
